import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InternalNavbar from '../../components/InternalNavbar';
import Footer from '../../components/footer';
import { toast } from 'react-toastify';
import couponService from '../../services/couponService';
import './style.css';

const RedeemPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleRedeem = async (e) => {
        e.preventDefault();
        if (!code.trim()) return;

        setLoading(true);
        try {
            const data = await couponService.redeemCoupon(code);
            setResult(data);
            toast.success(t('redeem.redeemSuccess'));
        } catch (error) {
            const msg = error.response?.data?.detail || t('redeem.redeemFailed');
            toast.error(msg);
            setResult(null);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="redeem-page">
            <div className="redeem-wrapper">
                <InternalNavbar />
                <div className="redeem-container">
                    <div className="redeem-card">
                        <h1>{t('redeem.title')}</h1>
                        <p>{t('redeem.description')}</p>

                        {!result ? (
                            <form onSubmit={handleRedeem} className="redeem-form">
                                <input
                                    type="text"
                                    placeholder={t('redeem.placeholder')}
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    disabled={loading}
                                />
                                <button type="submit" className="btn-primary" disabled={loading}>
                                    {loading ? t('redeem.redeeming') : t('redeem.redeemButton')}
                                </button>
                            </form>
                        ) : (
                            <div className="redeem-success">
                                <div className="success-icon">🎉</div>
                                <h2>{t('redeem.success')}</h2>
                                <p>{result.message}</p>
                                <div className="discount-details">
                                    <span>{t('redeem.discountApplied')}</span>
                                    <strong>
                                        {result.discount_type === 'percent'
                                            ? `${result.discount_value}${t('redeem.percentOff')}`
                                            : `$${result.discount_value}${t('redeem.amountOff')}`}
                                    </strong>
                                </div>
                                <button
                                    onClick={() => navigate('/dashboard')}
                                    className="btn-secondary"
                                >
                                    {t('redeem.goToDashboard')}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default RedeemPage;
